import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiTrendingDown,FiClock,FiAlertCircle}=FiIcons;

const PainSection=({openCheckoutPopup})=> {
  const painPoints=[
    {icon: FiTrendingDown, title: "No Consistent Leads", description: "You're relying on luck instead of a system.", color: "text-red-500"},
    {icon: FiClock, title: "Manual Follow-Ups", description: "Missed prospects = lost income.", color: "text-orange-500"},
    {icon: FiAlertCircle, title: "No Clear Offer", description: "Confused prospects never buy.", color: "text-yellow-500"}
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <motion.div 
          className="text-center mb-12"
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.6}}
          viewport={{once: true}}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Why You're Still <span className="text-red-500">Struggling to Grow Sales</span>
          </h2>
          <p className="text-lg text-gray-600">
            (and Losing Money Daily) 😩
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {painPoints.map((point, index)=> (
            <motion.div
              key={index}
              className="bg-white p-6 rounded-2xl shadow-lg card-hover text-center"
              initial={{opacity: 0, y: 30}}
              whileInView={{opacity: 1, y: 0}}
              transition={{duration: 0.6, delay: index * 0.1}}
              viewport={{once: true}}
            >
              <div className={`w-16 h-16 ${point.color} bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4`}>
                <SafeIcon icon={point.icon} className="w-8 h-8" />
              </div>
              <h3 className="font-bold text-xl text-gray-800 mb-2">{point.title}</h3>
              <p className="text-gray-600">{point.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div 
          className="text-center"
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.6, delay: 0.4}}
          viewport={{once: true}}
        >
          <p className="text-xl text-gray-700 mb-6">
            This Diwali, <strong className="gradient-text">end the struggle</strong>. These 24 proven ways will turn chaos into consistent sales. 🎯
          </p>
          <button 
            onClick={()=> document.getElementById('about')?.scrollIntoView({behavior: 'smooth'})}
            className="glow-button text-white px-8 py-3 rounded-xl font-semibold"
          >
            Show Me The Solution →
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default PainSection;